// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"95264b03","232":"26c3d329","426":"a9f52dd6"}[chunkId] + ".chunk.js";
};